export interface Chapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  description: string;
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  chapters: Chapter[];
  tags: string[];
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '动作', slug: 'action' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '悬疑', slug: 'mystery' },
  { name: '搞笑', slug: 'comedy' },
  { name: '日常', slug: 'slice-of-life' },
  { name: '剧情', slug: 'drama' },
  { name: '恐怖', slug: 'horror' },
  { name: 'BL/GL', slug: 'bl-gl' },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '我的野蛮女友',
    author: '金允熙',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20romance%20manhwa%20cover%20style%20art%2C%20a%20beautiful%20girl%20and%20boy%20in%20school%20uniform%20in%20a%20gentle%20embrace%2C%20soft%20pink%20and%20peach%20color%20palette%2C%20cherry%20blossom%20petals%20floating%20around%2C%20romantic%20illustration%20with%20delicate%20linework%2C%20clean%20simple%20background%20with%20gradient%2C%20Korean%20webtoon%20style%2C%20dreamy%20atmosphere&width=400&height=560&seq=comic-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '金雅琳是一个性格火爆的女孩，而李俊昊则是温文尔雅的学霸。两个性格迥异的人阴差阳错地成了同桌，从此展开了一段啼笑皆非又甜蜜浪漫的校园爱情故事。雅琳的野蛮背后隐藏着一颗柔软的心，俊昊能否发现她真实的一面？',
    rating: 9.2,
    views: 1285000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [],
    tags: ['校园', '恋爱', '喜剧'],
  },
  {
    id: '2',
    title: '剑与魔法',
    author: '朴正宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20manhwa%20cover%2C%20a%20warrior%20holding%20a%20glowing%20sword%20in%20epic%20fantasy%20setting%2C%20dark%20dramatic%20lighting%20with%20magical%20energy%20effects%2C%20intense%20battle%20pose%2C%20medieval%20armor%20design%2C%20clean%20simple%20dark%20background%2C%20Korean%20webtoon%20art%20style%2C%20dynamic%20composition&width=400&height=560&seq=comic-02&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '在一个魔法与剑术并存的世界，少年雷诺意外觉醒了传说中的龙骑士之力。为了守护王国免受黑暗势力的侵袭，他踏上了寻找失落圣剑的冒险之旅。一路上结识了各具特色的伙伴，共同对抗邪恶的魔王军团。',
    rating: 9.5,
    views: 2350000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [],
    tags: ['奇幻', '冒险', '战斗'],
  },
  {
    id: '3',
    title: '星空下的约定',
    author: '李美妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20drama%20manhwa%20cover%2C%20two%20people%20sitting%20under%20a%20beautiful%20starry%20night%20sky%2C%20emotional%20moment%2C%20warm%20golden%20and%20deep%20blue%20color%20palette%2C%20romantic%20and%20melancholic%20atmosphere%2C%20delicate%20illustration%2C%20Korean%20webtoon%20style%2C%20clean%20gradient%20background&width=400&height=560&seq=comic-03&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    description: '小时候在孤儿院相识的两个人，曾许下"长大后一起看星空"的约定。十年后，已成为天文学家的郑秀雅和落魄画家金道勋在城市中意外重逢。过去的记忆与当下的现实交织，他们能否守住那个星空下的约定？',
    rating: 9.0,
    views: 890000,
    status: '已完结',
    updatedAt: '2026-07-28',
    chapters: [],
    tags: ['重逢', '治愈', '成长'],
  },
  {
    id: '4',
    title: '鬼怪公寓',
    author: '崔东旭',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20horror%20manhwa%20cover%2C%20a%20mysterious%20apartment%20building%20in%20dark%20atmosphere%2C%20ghostly%20figures%20and%20shadows%2C%20eerie%20vibe%20with%20deep%20purple%20and%20black%20tones%2C%20thriller%20suspenseful%20mood%2C%20Korean%20webtoon%20style%2C%20clean%20dark%20background&width=400&height=560&seq=comic-04&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    description: '大学生金敏浩因为租金便宜，搬进了位于首尔郊区的一栋老旧公寓。然而他很快发现，这栋公寓里住着的不仅仅是普通居民——每到午夜时分，走廊里便会传来诡异的脚步声，而他的邻居们似乎都不是活人...',
    rating: 8.8,
    views: 1560000,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [],
    tags: ['恐怖', '悬疑', '都市'],
  },
  {
    id: '5',
    title: '会长大人是女仆',
    author: '韩素英',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20romantic%20comedy%20manhwa%20cover%2C%20a%20cute%20maid%20outfit%20girl%20looking%20embarrassed%20and%20a%20handsome%20rich%20boy%20smirking%2C%20bright%20and%20cheerful%20color%20palette%2C%20school%20setting%2C%20playful%20vibe%2C%20Korean%20webtoon%20style%2C%20clean%20pastel%20background&width=400&height=560&seq=comic-05&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '家境贫寒的学霸林恩星为了维持生计，偷偷在咖啡厅做兼职女仆。没想到被学校的霸道会长韩智勋发现了这个秘密！从此智勋以保守秘密为条件，对恩星展开了一系列令人捧腹的"特殊要求"。',
    rating: 9.1,
    views: 3120000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [],
    tags: ['校园', '恋爱', '喜剧'],
  },
  {
    id: '6',
    title: '异世界食堂',
    author: '张宇硕',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20slice%20of%20life%20manhwa%20cover%2C%20a%20warm%20cozy%20restaurant%20interior%20with%20delicious%20food%2C%20fantasy%20characters%20enjoying%20meals%2C%20soft%20warm%20lighting%2C%20comforting%20atmosphere%2C%20detailed%20food%20illustration%2C%20Korean%20webtoon%20style&width=400&height=560&seq=comic-06&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '一家只在周末营业的神秘餐厅，门开在不同的世界。精灵、矮人、兽人、魔族——来自各个世界的客人们汇聚于此，只为一尝主厨李承勋的绝世料理。美食跨越种族与世界的界限，温暖每一个疲惫的灵魂。',
    rating: 9.3,
    views: 1890000,
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters: [],
    tags: ['美食', '异世界', '治愈'],
  },
  {
    id: '7',
    title: '谜案追踪',
    author: '姜敏秀',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20mystery%20crime%20manhwa%20cover%2C%20a%20detective%20in%20trench%20coat%20examining%20evidence%20in%20a%20dimly%20lit%20room%2C%20mysterious%20atmosphere%20with%20clues%20scattered%2C%20dark%20blue%20and%20gray%20tones%2C%20suspenseful%20thriller%20mood%2C%20Korean%20webtoon%20style&width=400&height=560&seq=comic-07&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '前刑警赵贤宇因一次办案失误而辞职，成为私家侦探。某天，一位神秘委托人带来了五年前的连环失踪案的新线索。随着调查深入，他发现这背后隐藏着一个令人震惊的庞大犯罪网络，而真相远比想象中更加黑暗。',
    rating: 9.4,
    views: 2010000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [],
    tags: ['悬疑', '推理', '犯罪'],
  },
  {
    id: '8',
    title: '每天都是好日子',
    author: '郑多惠',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20slice%20of%20life%20manhwa%20cover%2C%20a%20young%20woman%20smiling%20while%20walking%20her%20dog%20in%20a%20beautiful%20park%2C%20sunny%20day%20with%20warm%20sunlight%2C%20peaceful%20and%20joyful%20atmosphere%2C%20soft%20green%20and%20yellow%20colors%2C%20Korean%20webtoon%20style&width=400&height=560&seq=comic-08&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    description: '平凡上班族金素妍的日常故事。没有惊天动地的大事，只有和同事一起吃午餐的快乐、周末遛狗的惬意、偶尔与老友相聚的温暖。在看似平淡的日子里，却处处闪耀着生活的小确幸。',
    rating: 8.7,
    views: 670000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [],
    tags: ['日常', '治愈', '轻松'],
  },
  {
    id: '9',
    title: '花与刀',
    author: '尹泰均',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20BL%20romance%20manhwa%20cover%2C%20two%20handsome%20men%20in%20historical%20Korean%20clothing%20standing%20close%20together%2C%20elegant%20and%20romantic%20atmosphere%2C%20cherry%20blossoms%20and%20traditional%20elements%2C%20soft%20aesthetic%20illustration%2C%20Korean%20webtoon%20style&width=400&height=560&seq=comic-09&orientation=portrait',
    category: 'BL/GL',
    categorySlug: 'bl-gl',
    description: '朝鲜时代，名门世家的公子李暄与武艺高强的护卫朴泰河之间的故事。一个是文雅的书生，一个是忠诚的武士，在主仆身份之外，两颗心渐渐靠近。然而时代的枷锁与家族的期望，让这段感情充满了荆棘。',
    rating: 9.6,
    views: 2780000,
    status: '已完结',
    updatedAt: '2026-07-15',
    chapters: [],
    tags: ['古风', 'BL', '虐心'],
  },
  {
    id: '10',
    title: '电竞之王',
    author: '宋俊贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20esports%20action%20manhwa%20cover%2C%20a%20young%20gamer%20with%20headset%20intensely%20playing%20on%20computer%2C%20futuristic%20gaming%20arena%20background%2C%20dynamic%20neon%20lighting%20effects%2C%20competitive%20esports%20atmosphere%2C%20Korean%20webtoon%20style&width=400&height=560&seq=comic-10&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '高中生姜泰贤是游戏"神域之战"的天才玩家，却因家境贫寒无法拥有自己的电脑。一次偶然的机会，他被顶级电竞俱乐部发掘，从此踏上了职业选手的道路。在聚光灯下，他必须面对强大的对手、热情的粉丝，以及自己内心深处的不安。',
    rating: 9.0,
    views: 1670000,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [],
    tags: ['电竞', '竞技', '热血'],
  },
  {
    id: '11',
    title: '甜蜜的谎言',
    author: '朴美英',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20romance%20manhwa%20cover%2C%20a%20beautiful%20woman%20in%20elegant%20dress%20and%20a%20handsome%20man%20in%20suit%2C%20luxurious%20party%20setting%2C%20glamorous%20and%20romantic%20atmosphere%2C%20sparkle%20effects%2C%20Korean%20webtoon%20style%2C%20clean%20elegant%20background&width=400&height=560&seq=comic-11&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '为了逃避家里安排的相亲，财阀千金韩智恩找到了平凡的公司职员金泰浩假扮自己的男友。一个是为了自由，一个是为了钱，这段始于谎言的关系在日复一日的相处中，渐渐变得真假难辨。',
    rating: 8.9,
    views: 1450000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [],
    tags: ['契约恋爱', '财阀', '浪漫'],
  },
  {
    id: '12',
    title: '重生之逆天改命',
    author: '金成焕',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20action%20manhwa%20cover%2C%20a%20powerful%20character%20with%20glowing%20eyes%20and%20dark%20aura%2C%20epic%20fantasy%20scene%20with%20destruction%20effects%2C%20intense%20and%20powerful%20vibe%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20style%2C%20clean%20dramatic%20background&width=400&height=560&seq=comic-12&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '被背叛而死的帝国骑士团长雷恩，意外重生回到了二十年前的少年时期。带着前世的记忆和战斗经验，他决心改变命运，保护那些曾因他而死的同伴，并向曾经的敌人发起复仇。',
    rating: 9.7,
    views: 4200000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [],
    tags: ['重生', '复仇', '战斗'],
  },
  {
    id: '13',
    title: '猫咪咖啡厅',
    author: '李瑞妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20cute%20slice%20of%20life%20manhwa%20cover%2C%20a%20cozy%20cat%20cafe%20with%20many%20cute%20cats%20and%20a%20happy%20barista%2C%20warm%20and%20inviting%20atmosphere%2C%20soft%20orange%20and%20cream%20colors%2C%20peaceful%20vibe%2C%20Korean%20webtoon%20style&width=400&height=560&seq=comic-13&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    description: '失业女孩崔允儿接手了外婆留下的猫咪咖啡厅。在这里，她遇到了各种各样的猫咪和客人——有失恋的白领、孤独的老人、好奇的小孩。通过与猫咪和客人的互动，允儿逐渐找回了生活的意义和快乐。',
    rating: 8.6,
    views: 520000,
    status: '已完结',
    updatedAt: '2026-06-20',
    chapters: [],
    tags: ['猫咪', '治愈', '温馨'],
  },
  {
    id: '14',
    title: '暗夜追踪者',
    author: '郑贤宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20noir%20crime%20manhwa%20cover%2C%20a%20mysterious%20figure%20in%20dark%20alley%20at%20night%2C%20rainy%20urban%20setting%2C%20noir%20cinematic%20lighting%2C%20suspenseful%20mood%2C%20dark%20blue%20and%20gray%20tones%2C%20Korean%20webtoon%20style&width=400&height=560&seq=comic-14&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '记者朴志勋在调查一桩失踪案件时，发现了一个隐藏在首尔繁华表面下的地下世界。一个自称为"追踪者"的神秘组织在暗中维护着城市的平衡。志勋不得不在报道真相和保护线人之间做出选择。',
    rating: 9.1,
    views: 1120000,
    status: '连载中',
    updatedAt: '2026-07-31',
    chapters: [],
    tags: ['犯罪', '悬疑', '都市'],
  },
  {
    id: '15',
    title: '校园怪诞录',
    author: '权娜英',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20school%20comedy%20manhwa%20cover%2C%20a%20group%20of%20funny%20high%20school%20students%20making%20silly%20faces%2C%20bright%20and%20colorful%20art%20style%2C%20energetic%20classroom%20setting%2C%20playful%20and%20humorous%20mood%2C%20Korean%20webtoon%20style&width=400&height=560&seq=comic-15&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '一所普通高中里发生的令人啼笑皆非的日常。有迷之自信的学生会长、永远在减肥的闺蜜团、暗恋校花却屡屡失败的倒霉蛋、以及总是说些奇怪哲理的语文老师。每个角色都有独特的笑点和故事。',
    rating: 8.5,
    views: 980000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [],
    tags: ['校园', '搞笑', '日常'],
  },
];

// Generate chapters for each comic
comics.forEach((comic) => {
  if (comic.title === '我的野蛮女友') {
    comic.chapters = [
      { id: '1-1', title: '第1话 命运的同桌', number: 1, updatedAt: '2025-01-10' },
      { id: '1-2', title: '第2话 初次交锋', number: 2, updatedAt: '2025-01-17' },
      { id: '1-3', title: '第3话 她的秘密', number: 3, updatedAt: '2025-01-24' },
      { id: '1-4', title: '第4话 心动时刻', number: 4, updatedAt: '2025-02-01' },
      { id: '1-5', title: '第5话 误会重重', number: 5, updatedAt: '2025-02-08' },
      { id: '1-6', title: '第6话 雨中的告白', number: 6, updatedAt: '2025-02-15' },
      { id: '1-7', title: '第7话 新的开始', number: 7, updatedAt: '2025-02-22' },
      { id: '1-8', title: '第8话 她的家人', number: 8, updatedAt: '2025-03-01' },
      { id: '1-9', title: '第9话 嫉妒的风暴', number: 9, updatedAt: '2025-03-08' },
      { id: '1-10', title: '第10话 真心话大冒险', number: 10, updatedAt: '2025-03-15' },
      { id: '1-11', title: '第11话 无法忘记的你', number: 11, updatedAt: '2025-03-22' },
      { id: '1-12', title: '第12话 守护', number: 12, updatedAt: '2025-03-29' },
      { id: '1-13', title: '第13话 盛夏的约定', number: 13, updatedAt: '2025-04-05' },
      { id: '1-14', title: '第14话 各自的路', number: 14, updatedAt: '2025-04-12' },
      { id: '1-15', title: '第15话 再会', number: 15, updatedAt: '2025-04-19' },
      { id: '1-16', title: '第16话 野蛮女友的温柔一面', number: 16, updatedAt: '2025-04-26' },
      { id: '1-17', title: '第17话 毕业季', number: 17, updatedAt: '2025-05-03' },
      { id: '1-18', title: '第18话 我们的故事还在继续', number: 18, updatedAt: '2025-05-10' },
    ];
  } else if (comic.title === '鬼怪公寓') {
    comic.chapters = [
      { id: '4-1', title: '第1话 新居', number: 1, updatedAt: '2025-06-01' },
      { id: '4-2', title: '第2话 诡异的邻居', number: 2, updatedAt: '2025-06-08' },
      { id: '4-3', title: '第3话 三楼的哭声', number: 3, updatedAt: '2025-06-15' },
      { id: '4-4', title: '第4话 墙上的水渍', number: 4, updatedAt: '2025-06-22' },
      { id: '4-5', title: '第5话 不要回头看', number: 5, updatedAt: '2025-06-29' },
      { id: '4-6', title: '第6话 地下室的秘密', number: 6, updatedAt: '2025-07-06' },
      { id: '4-7', title: '第7话 管理员大叔', number: 7, updatedAt: '2025-07-13' },
      { id: '4-8', title: '第8话 404房间', number: 8, updatedAt: '2025-07-20' },
      { id: '4-9', title: '第9话 镜子里的脸', number: 9, updatedAt: '2025-07-27' },
      { id: '4-10', title: '第10话 午夜访客', number: 10, updatedAt: '2025-08-03' },
      { id: '4-11', title: '第11话 真相浮现', number: 11, updatedAt: '2025-08-10' },
      { id: '4-12', title: '第12话 最后的夜晚', number: 12, updatedAt: '2025-08-17' },
    ];
  } else {
    const chapterCount = 8 + Math.floor(Math.random() * 12);
    for (let i = 1; i <= chapterCount; i++) {
      const year = 2025 + Math.floor(i / 20);
      const month = String((i % 12) + 1).padStart(2, '0');
      const day = String((i * 3) % 28 + 1).padStart(2, '0');
      comic.chapters.push({
        id: `${comic.id}-${i}`,
        title: `第${i}话`,
        number: i,
        updatedAt: `${year}-${month}-${day}`,
      });
    }
  }
});

export const hotComics = comics.filter(c => c.rating >= 9.2).sort((a, b) => b.rating - a.rating).slice(0, 6);
export const latestComics = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);
export const rankingComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);